import { formatCurrency } from './formatCurrency';

export function formatPnl(amount, unrealized = false) {
  return `${formatCurrency(Math.abs(amount))}${unrealized ? ' unrealized' : ''} ${amount < 0 ? 'loss' : 'profit'}`;
}
